import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from 'environment';
import { Amplify } from 'aws-amplify';
import awsmobile from './manual-aws-exports';
import { Preferences } from '@capacitor/preferences';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

// Add this BEFORE Amplify.configure to monitor localStorage changes
const originalRemoveItem = Storage.prototype.removeItem;
Storage.prototype.removeItem = function(key: string) {
  if (key.includes('CognitoIdentityServiceProvider')) {
    console.error('🚨 COGNITO TOKEN BEING REMOVED:', key);
    console.trace(); // Shows the call stack
  }
  return originalRemoveItem.apply(this, arguments as any);
};

const originalClear = Storage.prototype.clear;
Storage.prototype.clear = function() {
  console.error('🚨 localStorage.clear() called');
  console.trace();
  return originalClear.apply(this, arguments as any);
};

// CRITICAL: Set storage FIRST, before any Amplify config
const capacitorStorage = {
  async setItem(key: string, value: string): Promise<void> {
    console.log('✅ Storing in Preferences:', key.substring(0, 50));
    await Preferences.set({ key, value });
  },
  async getItem(key: string): Promise<string | null> {
    const { value } = await Preferences.get({ key });
    console.log('📖 Reading from Preferences:', key.substring(0, 50), value ? '(found)' : '(not found)');
    return value;
  },
  async removeItem(key: string): Promise<void> {
    console.log('🗑️ Removing from Preferences:', key.substring(0, 50));
    await Preferences.remove({ key });
  },
  async clear(): Promise<void> {
    console.log('🧹 Clearing Preferences');
    await Preferences.clear();
  }
};

// Set custom storage BEFORE configuring Amplify
cognitoUserPoolsTokenProvider.setKeyValueStorage(capacitorStorage);

// First, log your configuration to verify it's correct
Amplify.configure(awsmobile, {
  // ssr: true,// Enables cookie storage for authentication tokens
});
console.log('Amplify configured with:', Amplify.getConfig());

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
